import { Component, Input } from '@angular/core';

@Component({
    selector: 'fab',
    templateUrl: './fab.component.html',
    styleUrls: ['./fab.component.scss'],
    standalone: false
})
export class FabComponent {
  @Input() title: string;
  @Input() routerLink: string;
  @Input() icon: string;
  @Input() style: string;
}
